import $ from 'jquery';

const notification = () => {
    const $notification = $('.s-notification');
    if (!$notification.length) { return; }

    // Loop through all the notifications on the page
    $notification.each(function () {
        const $closeBtn = $(this).find('.close-icon');

        $closeBtn.click(() => {
            $(this).addClass('hide');
        });
    });
};

$(() => {
    notification();
});



// WEBPACK FOOTER //
// ./src/sections/notification/s-notification.js